import { render, staticRenderFns } from "./ReminderIcon.vue?vue&type=template&id=6c205d51&scoped=true"
import script from "./ReminderIcon.vue?vue&type=script&lang=js"
export * from "./ReminderIcon.vue?vue&type=script&lang=js"
import style0 from "./ReminderIcon.vue?vue&type=style&index=0&id=6c205d51&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c205d51",
  null
  
)

export default component.exports